var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _g, _path22, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBesscard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 125,
    viewBox: "0 0 91 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0697 97.4243C16.2412 92.5741 28.4273 84.9798 37.898 83.5391C40.5231 83.1403 43.1564 82.9751 45.7458 82.9895L45.7883 82.9729L45.8123 82.9895C72.0163 85.4148 86.0287 95.033 89.4803 102.346C93.6415 111.162 84.4256 120.223 68.8978 122.585C66.5046 122.949 64.1058 123.112 61.7378 123.13L61.7217 123.149L22.0353 123.041L3.13965 106.755L13.0674 97.4243H13.0697Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2121 31.8724C22.8795 38.9849 43.1298 38.7805 55.4434 31.4153C61.4977 27.7936 64.5059 23.1148 64.4923 18.4484L64.5991 105.551C64.6127 110.218 61.6049 114.897 55.5502 118.518C43.2365 125.883 22.9863 126.088 10.319 118.975C3.88105 115.36 0.640741 110.552 0.627387 105.73L0.520508 18.6273C0.533862 23.4493 3.77422 28.2586 10.2121 31.8724Z",
    fill: "url(#paint0_linear_143_13242)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2119 31.8725C22.8793 38.9849 43.1295 38.7806 55.4432 31.4154C67.7551 24.0507 67.4682 12.3157 54.8005 5.20323C42.1332 -1.90922 21.883 -1.70441 9.56943 5.66033C-2.74408 13.0251 -2.4556 24.76 10.2119 31.8725ZM17.7186 10.235C25.656 5.48673 38.7125 5.35443 46.8802 9.93959C55.0478 14.5248 55.2319 22.0912 47.294 26.8395C39.3561 31.5877 26.3 31.72 18.1324 27.1348C9.96479 22.5497 9.78047 14.9832 17.7186 10.235Z",
    fill: "#F4F4F4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1224 23.5771C26.2901 28.1627 39.3461 28.0304 47.284 23.2822C51.188 20.9474 53.1274 17.9296 53.1182 14.9215L53.1274 18.479C53.1353 21.4872 51.1976 24.5037 47.2932 26.8393C39.3553 31.5875 26.2993 31.7198 18.1316 27.1347C13.9804 24.8043 11.8914 21.7039 11.8834 18.5951L11.874 15.0375C11.8834 18.1463 13.9724 21.2468 18.1224 23.5771Z",
    fill: "url(#paint1_linear_143_13242)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1218 23.5772C26.2895 28.1628 39.3455 28.0305 47.2834 23.2823C55.2213 18.5341 55.0368 10.9672 46.8692 6.38201C38.7015 1.79685 25.6468 1.92914 17.7076 6.67737C9.76978 11.4256 9.95411 18.9921 18.1218 23.5772ZM26.2772 11.4884C29.6166 9.49166 35.1073 9.43585 38.5416 11.3641C41.9768 13.2923 42.0542 16.4744 38.7151 18.4712C35.3757 20.4676 29.885 20.5238 26.4511 18.5952C23.0168 16.667 22.9382 13.4848 26.2772 11.4884Z",
    fill: "url(#paint2_linear_143_13242)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9016 11.4646C33.4351 10.5464 35.4238 10.0401 37.4581 9.94515C37.6369 9.93724 37.8174 9.93197 37.9976 9.93021C40.2173 9.9078 42.448 10.3755 44.1656 11.3402C47.5999 13.2689 47.6786 16.4506 44.3395 18.4474C42.6764 19.4416 40.4791 19.955 38.2686 19.9813C38.1698 19.9813 31.6477 19.9827 31.5488 19.9813L31.9003 11.4633L31.9016 11.4646Z",
    fill: "#9B9BA0"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4414 15.039C29.877 16.9676 35.3677 16.9114 38.7058 14.915C40.347 13.9327 41.1632 12.6642 41.1593 11.3988L41.1698 14.9564C41.1738 16.2218 40.358 17.4902 38.7164 18.4726C35.3774 20.4689 29.8863 20.5252 26.4524 18.5965C24.7066 17.6173 23.8276 16.3127 23.825 15.0056L23.8145 11.4485C23.8184 12.7552 24.697 14.0597 26.4414 15.039Z",
    fill: "url(#paint3_linear_143_13242)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.267 7.93108C29.606 5.9343 35.0971 5.87848 38.531 7.8067C41.9649 9.73535 42.0439 12.9171 38.7049 14.9139C35.3655 16.9102 29.8744 16.9665 26.4405 15.0378C23.0052 13.1096 22.9279 9.92742 26.267 7.93108Z",
    fill: "url(#paint4_linear_143_13242)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5818 45.1549V115.593C21.5732 115.185 12.5745 112.935 6.37305 107.856V37.417C9.58397 40.0458 13.5429 41.9169 17.7276 43.1678C21.6263 44.333 25.72 44.9584 29.5831 45.1549H29.5818Z",
    fill: "#5B5B5B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8836 49.2377C19.1127 54.1341 25.9902 53.6211 29.5818 54.2263V59.0027C20.1038 58.372 10.0448 54.3028 6.37305 50.8415V46.7935C7.68067 46.6533 9.2354 48.2672 10.8836 49.2364V49.2377Z",
    fill: "#656568"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 64.4861V60.4129C7.68335 60.2741 9.24071 61.8898 10.8836 62.8545C12.7522 63.9665 15.4396 65.1717 18.2763 66.0029C23.6123 67.612 27.323 67.5962 29.5818 67.8713V72.6195C20.5299 72.0156 10.1423 67.9821 6.37305 64.4861Z",
    fill: "url(#paint5_linear_143_13242)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5818 52.1942C21.875 51.6835 13.0835 49.1324 6.37305 43.9482V39.9806C6.84853 39.883 7.37748 39.9753 7.89171 40.3722C14.2642 45.254 21.4607 46.8829 29.5818 47.4486V52.1942Z",
    fill: "#656568"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89171 94.8425C10.6271 96.9382 13.762 98.7249 18.2763 100.049C23.5926 101.653 27.3138 101.658 29.5818 101.952V106.666C21.8174 106.152 13.0487 103.575 6.37305 98.4203V94.4764C6.87392 94.3828 7.41886 94.4791 7.89171 94.8425Z",
    fill: "url(#paint6_linear_143_13242)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 57.5664V53.5984C6.84853 53.5008 7.37748 53.5931 7.89171 53.9887C17.2211 61.1345 25.5 60.3381 29.5818 61.0277V65.8107C21.8829 65.3013 13.0714 62.7379 6.37305 57.5651V57.5664Z",
    fill: "url(#paint7_linear_143_13242)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 105.228V101.261C6.84853 101.165 7.37879 101.256 7.89171 101.65C10.6258 103.746 13.762 105.533 18.2763 106.857C23.6123 108.466 27.323 108.449 29.5818 108.725V113.471C21.7585 112.935 13.0514 110.389 6.37305 105.229V105.228Z",
    fill: "url(#paint8_linear_143_13242)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89171 67.6065C14.0385 72.3173 22.2207 74.4407 29.5818 74.6961V79.4284C21.5424 78.8966 12.9526 76.2704 6.37305 71.1855V67.2175C6.84853 67.1212 7.37879 67.2122 7.89171 67.6065Z",
    fill: "url(#paint9_linear_143_13242)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M6.37305 73.9774C7.52437 73.8451 8.84671 75.274 10.8836 76.4726C16.5829 79.8631 23.2613 81.0525 29.5818 81.4933V86.2376C20.2215 85.6148 10.0715 81.5602 6.37305 78.0883V73.9761V73.9774Z",
    fill: "url(#paint10_linear_143_13242)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6493 92.5828C18.5662 91.5095 11.9735 89.1615 6.37305 84.8168V80.8584C6.87392 80.7648 7.41886 80.861 7.89171 81.2245C10.5791 83.2841 13.623 85.0655 18.2763 86.4311C23.6501 88.0521 27.3406 88.0455 29.5818 88.3088V93.0386C28.3874 93.0597 26.9676 92.7859 25.6493 92.5828Z",
    fill: "url(#paint11_linear_143_13242)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.89171 88.0337C14.2361 92.8967 21.5262 94.5471 29.5818 95.1097V99.8579C29.2172 99.8315 27.7289 99.7111 25.6493 99.3916C18.7547 98.3468 12.071 96.0428 6.37305 91.6247V87.6447C6.84853 87.5485 7.37879 87.6395 7.89171 88.0337Z",
    fill: "url(#paint12_linear_143_13242)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M7.85964 38.4943V106.997C13.6832 111.765 21.9628 114.017 29.5818 114.616V115.593C21.5732 115.185 12.5745 112.935 6.37305 107.856V37.4183C6.84322 37.8034 7.35876 38.1414 7.85964 38.4956V38.4943Z",
    fill: "#5B5B5B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_143_13242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 37,
    width: 24,
    height: 79
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8143 37.103H6.09277V115.735H29.8143V37.103Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_143_13242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.09277,
    y: 37.103,
    width: 23.7215,
    height: 78.6323,
    fill: "url(#pattern0_143_13242)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_143_13242",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 24,
    y: 8,
    width: 12,
    height: 9
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M35.525 8.98853H24.1035V16.4564H35.525V8.98853Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_143_13242)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24.1035,
    y: 8.98853,
    width: 11.4215,
    height: 7.46788,
    fill: "url(#pattern1_143_13242)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_143_13242",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_143_13242",
    transform: "scale(0.0185185 0.00558659)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_143_13242",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_143_13242",
    transform: "scale(0.0384615 0.0588235)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_143_13242",
    x1: 64.6021,
    y1: 71.3127,
    x2: 0.51673,
    y2: 71.3127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2C4C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEDED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_143_13242",
    x1: 53.1287,
    y1: 22.706,
    x2: 11.8702,
    y2: 22.706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#929296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_143_13242",
    x1: 53.115,
    y1: 14.9805,
    x2: 11.8697,
    y2: 14.9805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7D7DD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_143_13242",
    x1: 41.1606,
    y1: 15.7035,
    x2: 23.8105,
    y2: 15.7035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7C7C80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#929296"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBDC5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_143_13242",
    x1: 41.161,
    y1: 11.4231,
    x2: 23.8109,
    y2: 11.4231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D6D6DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFDFE5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_143_13242",
    x1: 29.5805,
    y1: 66.5123,
    x2: 6.36641,
    y2: 66.5123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_143_13242",
    x1: 29.5805,
    y1: 100.553,
    x2: 6.36641,
    y2: 100.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_143_13242",
    x1: 29.5805,
    y1: 59.6872,
    x2: 6.36641,
    y2: 59.6872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_143_13242",
    x1: 29.5805,
    y1: 107.349,
    x2: 6.36641,
    y2: 107.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_143_13242",
    x1: 29.5805,
    y1: 73.3063,
    x2: 6.36641,
    y2: 73.3063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_143_13242",
    x1: 29.5805,
    y1: 80.1036,
    x2: 6.36641,
    y2: 80.1036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_143_13242",
    x1: 29.5805,
    y1: 86.9322,
    x2: 6.36641,
    y2: 86.9322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_143_13242",
    x1: 29.5805,
    y1: 93.7335,
    x2: 6.36641,
    y2: 93.7335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51B1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.672,
    stopColor: "#65C0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72C9B2"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_143_13242",
    width: 54,
    height: 179,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_143_13242",
    width: 26,
    height: 17,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAARCAYAAADDjbwNAAAAAXNSR0IArs4c6QAAAIRlWElmTU0AKgAAAAgABQESAAMAAAABAAEAAAEaAAUAAAABAAAASgEbAAUAAAABAAAAUgEoAAMAAAABAAIAAIdpAAQAAAABAAAAWgAAAAAAAACQAAAAAQAAAJAAAAABAAOgAQADAAAAAQABAACgAgAEAAAAAQAAABqgAwAEAAAAAQAAABEAAAAAKSFmjgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAWFJREFUOBG9lFFugzAMhhPKMaap6iKhHoGdo70InGNcpDvHOEJUiVFUdbdok/l3GhomUGFF9QPYieMvcewI8SSRIaeqmnfYURSnxkA7l0otv6A9KgwCYLGIdwhmreWYDuR0DEkpCkwo9frBDhM/DKrr0ycFSrF2COTiWpqHjyySZBqQQYfD6cdvcAwo8OVTJsny7iljv+h/f5lh3X7fCGPO5XqtBu8zgiOlo8T/AcmkjHdaN/lQDAbRbjgFQ05jx+meM63rXlhb3lQQORyn3ZHfgisSZ3n9sg1T2YLghOqjRHL1/S3vbpCr5aqfDB8c46F+g3Hq3DIhVquXDXXMLGl0MSPuTegdEAYIRqU6H0zrb8pSD+gGu2xJn+10nTsCpE+q6phTC1DPhPkn6+4dwcFSf71tRoE83AFtSoDrc+Vnwg2EuqH+tAWqbxLIh/V/ehHannFVihk8+wAIEZY37KfIL9Hmu2oHGz8/AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBesscard);
export default __webpack_public_path__ + "static/media/Besscard.08ea6ad18d517681cf0bdfc8eca26538.svg";
export { ForwardRef as ReactComponent };